export const OrganikFoodIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.3734 10.6975C12.62 13.5819 9.86667 20.6579 9.86667 20.6579C9.86667 20.6579 5.93335 10.6975 2 8.39893"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.4987 4.58436L21.9734 9.51455C22.2814 12.7129 19.8833 15.5605 16.6851 15.8686C13.5468 16.1707 10.7039 13.8768 10.4017 10.7387C10.0995 7.60036 12.3985 4.81135 15.5368 4.50918L20.7935 4.00302C21.1488 3.96881 21.4645 4.22909 21.4987 4.58436Z"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
